import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { AuthService, TohumUiModule } from '@anadolu-commons/tohum-ui';
import { SharedService } from '../shared.service';
import { ProfilResimComponent } from '../profil-resim/profil-resim.component';
import { AofMenuService } from '../services/aof-menu.service';

export interface AofMenuItem {
    label?: string;           // navigasyon item'ı için
    link?: string | any[];    // navigasyon item'ı için
    icon?: string;            // navigasyon item'ı için
    exact?: boolean;
    isBackLink?: boolean;     // "Anasayfa'ya Dön" gibi özel stil için
    menuTitle?: string;       // sadece bu varsa → grup başlığı olarak render edilir
}

@Component({
    selector: 'aof-menu',
    standalone: true,
    imports: [CommonModule, RouterModule, TohumUiModule, ProfilResimComponent],
    templateUrl: './aof-menu.component.html',
    styleUrls: ['./aof-menu.component.scss']
})
export class AofMenuComponent implements OnInit {
    private _items: AofMenuItem[] = [];
    menuTitle: string = 'menu.header';

    backLink: { url: string, label: string } | null = null;
    profilId: string;
    adayBilgi: string;
    resimBasariliMi: boolean = false;
    adaySorgulamasiYapildiMi: boolean = false;

    get items(): AofMenuItem[] { return this._items; }

    get hasNavItems(): boolean {
        return this._items.some(i => !i.menuTitle);
    }

    get profilParams() {
        return {
            returnUrl: this.router.url.split('?')[0],
            returnLabel: this.menuTitle
        };
    }

    constructor(
        private authService: AuthService,
        private sharedService: SharedService,
        private route: ActivatedRoute,
        public router: Router,
        private aofMenuService: AofMenuService
    ) {
        this.sharedService.profil$.subscribe((data) => {
            if (data) {
                this.profilId = data.profilId;
                this.adaySorgulamasiYapildiMi = true;
            }
        });
        this.sharedService.profilAdSoyad$.subscribe((data) => {
            if (data) {
                this.adayBilgi = data.ad + ' ' + data.soyad;
            }
        });

        // Menü Servisini Dinle
        this.aofMenuService.menuItems$.subscribe(items => {
            if (items) {
                this._items = items;
                const titleItem = items.find(i => i.menuTitle);
                this.menuTitle = titleItem?.menuTitle ?? 'menu.header';
            }
        });
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            const returnUrl = params['returnUrl'];
            const currentPath = this.router.url.split('?')[0];

            if (returnUrl && returnUrl !== currentPath) {
                this.backLink = {
                    url: returnUrl,
                    label: params['returnLabel'] || this.menuTitle
                };
            } else {
                this.backLink = null;
            }
        });
    }

    resimHata(event: any): void {
        this.resimBasariliMi = false;
    }

    // Mobil menü kontrolü
    isMenuOpen: boolean = false;
    toggleMenu(): void {
        this.isMenuOpen = !this.isMenuOpen;
    }
}
